import { Tag_Color as PBTagColor } from "gen/tag/models_pb"

import { TagColor } from "./types"

// extractTagColor convers the Tag_Color enum value to the more human readable TagColor type.
export function extractTagColor(color: PBTagColor): TagColor {
  return (
    {
      [PBTagColor.UNDEFINED]: TagColor.Undefined,
      [PBTagColor.RED]: TagColor.Red,
      [PBTagColor.PINK]: TagColor.Pink,
      [PBTagColor.PURPLE]: TagColor.Purple,
      [PBTagColor.BLUE]: TagColor.Blue,
      [PBTagColor.CYAN]: TagColor.Cyan,
      [PBTagColor.GREEN]: TagColor.Green,
      [PBTagColor.YELLOW]: TagColor.Yellow,
      [PBTagColor.GRAY]: TagColor.Gray,
    }[color] ?? TagColor.Undefined
  )
}

export function extractTagColorLabel(color: PBTagColor): string {
  return (
    {
      [PBTagColor.UNDEFINED]: "",
      [PBTagColor.RED]: "Red",
      [PBTagColor.PINK]: "Pink",
      [PBTagColor.PURPLE]: "Purple",
      [PBTagColor.BLUE]: "Blue",
      [PBTagColor.CYAN]: "Cyan",
      [PBTagColor.GREEN]: "Green",
      [PBTagColor.YELLOW]: "Yellow",
      [PBTagColor.GRAY]: "Gray",
    }[color] ?? ""
  )
}
